"use client";
import ErrorTrace from "@/components/ErrorTrace";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  console.debug("GlobalError", { error });
  return (
    <>
      <h1 className="text-2xl mb-2">{error.name}</h1>
      <h2 className="text-2xl mb-1">{error.message}</h2>
      <ErrorTrace error={error} reset={reset} />
    </>
  );
}
